// 机场存储容量：总容量（单位：KB）、已使用（单位：KB）
export interface AirportStorage {
    total: number, // 单位：KB
    used: number
  }
  
  // 舱盖状态
  export enum CoverStateEnum {
    Close = 0, // 关闭
    Open = 1, // 打开
    HalfOpen = 2, // 半打开
    Failed = 3 // 失败
  }
  
  export enum DeviceTypeName {
    // 飞行器 = 0,
    // 网关 = 2,
    // 机场 = 3,
    Aircraft = 0,
    Gateway = 2,
    Dock = 3,
  }
  // 推杆状态
  export enum PutterStateEnum {
    Close = 0, // 关闭
    Open = 1, // 打开
    HalfOpen = 2, // 半打开
    Failed = 3 // 失败
  }
  
  // 充电状态
  export enum ChargeStateEnum {
    NotCharge = 0, // 空闲
    Charge = 1, // 正在充电
  }
  
  // 补光灯状态
  export enum SupplementLightStateEnum {
    Close = 0, // 关闭
    Open = 1, // 打开
  }
  
  // 机场声光报警状态
  export enum AlarmModeEnum {
    CLOSE = 0, // 关闭
    OPEN = 1, // 开启
  }
  
  // 电池保养
  export enum BatteryStoreModeEnum {
    BATTERY_PLAN_STORE = 1, // 电池计划存储策略
    BATTERY_EMERGENCY_STORE = 2, // 电池应急存储策略
  }
  
  // 飞行器电池保养
  export enum DroneBatteryStateEnum {
    NoMaintenanceRequired = 0, // 0-无需保养
    MaintenanceRequired = 1, // 1-待保养
    MaintenanceInProgress = 2, // 2-正在保养
  }
  
  export enum DroneBatteryModeEnum {
    CLOSE = 0, // 关闭
    OPEN = 1, // 开启
  }
  
  // 4g链路连接状态
  export enum FourGLinkStateEnum {
    CLOSE = 0, // 断开
    OPEN = 1, // 连接
  }
  
  //  Sdr链路连接状态
  export enum SdrLinkStateEnum {
    CLOSE = 0, // 断开
    OPEN = 1, // 连接
  }
  
  // 机场的图传链路模式
  export enum LinkWorkModeEnum {
    SDR = 0, // sdr模式
    FourG_FUSION_MODE = 1, // 4G融合模式
  }
  
  export enum DroneInDockEnum {
    // 舱外, 舱内
    OUTSIDE, INSIDE
  }
  export enum NetworkStateTypeEnum {
    FOUR_G = 1,
    ETHERNET = 2,
  }
  
  export enum NetworkStateQualityEnum {
    NO_SIGNAL = 0,
    BAD = 1,
    POOR = 2,
    FAIR = 3,
    GOOD = 4,
    EXCELLENT = 5,
  }
  
  export enum RainfallEnum {
    NONE = 0,
    小雨 = 1,
    中雨 = 2,
    大雨 = 3,
  }
  
  export enum DrcStateEnum {
    DISCONNECT = 0,
    CONNECTING = 1,
    CONNECTED = 2
  }
  
  // 夜航灯开关
  export enum NightLightsStateEnum {
    CLOSE = 0, // 0-关闭
    OPEN = 1, // 1-打开
  }
  
  // 限远开关
  export enum DistanceLimitStatusEnum {
    UNSET = 0, // 0-未设置
    SET = 1, // 1-已设置
  }
  
  // 避障
  export enum ObstacleAvoidanceStatusEnum {
    CLOSE = 0, // 0-关闭
    OPEN = 1, // 1-开启
  }
  
  
  export enum CameraMode {
    Photo = 0, // 拍照
    Video = 1, // 录像
  }

  export enum recordingState{
    idle = 0, //空闲
    recording = 1, //录像中
  }
  
  // 控制权
  export enum ControlSource {
    A = 'A',
    B = 'B'
  }
  
  export enum EBizCode {
    GatewayOsd = 'gateway_osd',
    DeviceOsd = 'device_osd',
    DockOsd = 'dock_osd',
    MapElementCreate = 'map_element_create',
    MapElementUpdate = 'map_element_update',
    MapElementDelete = 'map_element_delete',
    DeviceOnline = 'device_online',
    DeviceOffline = 'device_offline',
    DeviceHms = 'device_hms',
  
    // 机场任务
    FlightTaskProgress = 'flighttask_progress', // 机场任务执行进度
    FlightTaskMediaProgress = 'file_upload_callback', // 机场任务媒体上传进度
    FlightTaskMediaHighestPriority = 'highest_priority_upload_flighttask_media', // 机场任务媒体优先级上报
  
    // 设备指令
    DeviceReboot = 'device_reboot', // 机场重启
    DroneOpen = 'drone_open', // 飞行器开机
    DroneClose = 'drone_close', // 飞行器关机
    DeviceFormat = 'device_format', // 机场数据格式化
    DroneFormat = 'drone_format', // 飞行器数据格式化
    CoverOpen = 'cover_open', // 打开舱盖
    CoverClose = 'cover_close', // 关闭舱盖
    PutterOpen = 'putter_open', // 推杆展开
    PutterClose = 'putter_close', // 推杆闭合
    ChargeOpen = 'charge_open', // 打开充电
    ChargeClose = 'charge_close', // 关闭充电
  
    // 设备升级
    DeviceUpgrade = 'ota_progress', // 设备升级
  
    // 设备日志
    DeviceLogUploadProgress = 'fileupload_progress', // 设备日志上传
  
    // 飞行指令消息
    ControlSourceChange = 'control_source_change', // 控制权更新
    FlyToPointProgress = 'fly_to_point_progress', // 飞向目标点
    TakeoffToPointProgress = 'takeoff_to_point_progress', // 一键起飞
    JoystickInvalidNotify = 'joystick_invalid_notify', // 设备端退出drc模式
    DrcStatusNotify = 'drc_status_notify', // 飞行控制模式状态
  }
  